import "app/themes/default/default.scss";
import { OddsType } from "app/utils/const";
import { CSSProperties, PureComponent } from "react";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { BarLoader, MoonLoader, PulseLoader } from "react-spinners";
import { $Values } from "utility-types";
import CurrencyNumber from "../../components/CurrencyNumber/CurrencyNumber";
import { SessionHelper } from "../../helpers/sessionHelper";
import "../../themes/default/colors.scss";
import "./LoadingSpinner.scss";
//
type Props = {
  data?: Record<string, any>;
  // BET-4928 data object only used in betslip

  /** The style of the loading spinner */
  spinner: "pulse" | "bar" | "moon";

  /** Optional text to show if spinner "bar" is selected */
  text?: string;
  intl: $Values<typeof intlShape>;
  oddsType?: string;
  betSlipOdd: any;
  selectedOdd?: number;
};
/** Loading spinner with different styles and optional text */

class LoadingSpinner extends PureComponent<Props> {
  static defaultProps = {
    spinner: "pulse",
  };
  // BET-6185 Negative Malay Odds - bet progress displays return amount first
  // update for malay odds
  alternativeProcessingMessageForNegativeMalayOdds = (
    betslip: Record<string, any>
  ) => {
    const { oddsType, selectedOdd, betSlipOdd } = this.props;

    if (
      oddsType === OddsType.MALAY &&
      betSlipOdd["aggregatedPrices"][selectedOdd].odds < 0
    ) {
      return <FormattedMessage tagName="span" id="bets-stake" />;
    }

    return (
      <CurrencyNumber
        value={parseInt(betslip.stake)}
        minimumFractionDigits={0}
      />
    );
  };
  // progress bar for display of incremental acceptance of bets on betslip
  calculatedBetPercentagePlaced = (betslip: Record<string, any>) => {
    let percent = 0;
    // logic to manage inline styling
    // check if dark mode class is added to DOM
    const element = document.querySelector(".dark");
    //extract styles from DOM Document Element
    const styles = element
      ? getComputedStyle(element)
      : getComputedStyle(document.documentElement);
    const loadingBarColor = styles.getPropertyValue("--soft-highlight-color");

    if (betslip["requestedStake"] === undefined) {
      // if waiting for response from API return placeholder progress bar
      return (
        <div
          className={`progress-bar ${
            SessionHelper.isAsianRouteAndSessionView() ? "asia" : "europe"
          }`}
          style={{
            background: `#d7e2e7`,
          }}
        >
          <CurrencyNumber value={"0"} minimumFractionDigits={0} />{" "}
          {this.props.intl.formatMessage({
            id: "bets-of",
          })}{" "}
          {/* BET-6185 */}
          {this.alternativeProcessingMessageForNegativeMalayOdds(betslip)}{" "}
          {this.props.intl.formatMessage({
            id: "bets-confirmed",
          })}
        </div>
      );
    } else {
      // if API returns requested stake update progress bar
      percent = (parseInt(betslip.stake) / betslip["requestedStake"]) * 100;
      // return progress bar
      return (
        <div
          className={`progress-bar ${
            SessionHelper.isAsianRouteAndSessionView() ? "asia" : "europe"
          }`}
          style={{
            background: `linear-gradient(90deg, ${loadingBarColor} ${percent}%, rgba(215,226,231,1) ${percent}%)`,
          }}
        >
          <CurrencyNumber
            value={parseInt(betslip.stake)}
            minimumFractionDigits={0}
          />{" "}
          {this.props.intl.formatMessage({
            id: "bets-of",
          })}{" "}
          <CurrencyNumber
            value={betslip["requestedStake"]}
            minimumFractionDigits={0}
          />{" "}
          {this.props.intl.formatMessage({
            id: "bets-confirmed",
          })}
        </div>
      );
    }
  };

  render() {
    const { spinner, text, data } = this.props;
    // adding inline custom style to override default component width
    const spinnerBar: CSSProperties = {
      width: "100%",
    };

    switch (spinner) {
      case "bar":
        return (
          <div className="spinner-box">
            {text && <div className="spinner-box__text">{text}</div>}
            {/* BET-4928 display progress bar for incremental accptance of bets on betslip only */}
            {/* BET-5527 disable incremental bets for hotfix 2.0.2 */}
            {data &&
              data.betSlip &&
              this.calculatedBetPercentagePlaced(data.betSlip)}
            <div className="spinner-box__wrapper">
              <BarLoader cssOverride={spinnerBar} color="currentColor" />
            </div>
          </div>
        );

      case "moon":
        return (
          <div className="loading-spinner">
            <MoonLoader size={20} color={"grey"} />
          </div>
        );
      case "pulse":
      default:
        return (
          <div className="loading-spinner">
            <PulseLoader size={12} color={"currentColor"} />
          </div>
        );
    }
  }
}

export default injectIntl(LoadingSpinner) as any;
